import { AEntity } from "./a-entity";

export class User extends AEntity {
    login: string;
    firstName: string;
    lastName: string;

    version: string;

    isInactive: boolean;
    neverLogWith: boolean;

    accessGroupId: number;
    languageId: number;

    get fullName(): string {
        return (this.firstName + ' ' + this.lastName).trim();
    }
}